import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { URLGuard } from './gurd.guard';
import { PartnerGuard } from './services/partner.guard';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { HomeComponent } from './components/home/home.component';
import { GuidePagesComponent } from './components/guide-pages/guide-pages.component';
import { NewsComponent } from './components/news/news.component';
import { NewTripComponent } from './components/trip/new-trip/new-trip.component';
import { AllTripComponent } from './components/trip/all-trip/all-trip.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SupportComponent } from './components/support/support.component';
import { PaymentComponent } from './components/payment/payment.component';
import { HomeMarketersComponent } from './components/marketers/home-marketers/home-marketers.component';
import { PartnerDashboardComponent } from './components/_Partners/partner-dashboard/partner-dashboard.component';
import { PartnerTripsComponent } from './components/_Partners/partner-trips/partner-trips.component';
import { PartnerFinancialComponent } from './components/_Partners/partner-financial/partner-financial.component';
import { DriverAdsComponent } from './components/driver-ads/driver-ads.component';
import { TaxilonAdsDetailComponent } from './components/taxilon-ads-detail/taxilon-ads-detail.component';
import { EducationComponent } from './components/education/education.component';
import { RouteComponent } from './components/route/route.component';
import { FullPaymentComponent } from './components/full-payment/full-payment.component';

const routes: Routes = [

  { path: '', redirectTo: 'taxilon/home', pathMatch: 'full' },
  { path: 'taxilon', redirectTo: 'taxilon/home', pathMatch: 'full' },
  {
    path: 'taxilon', component: LandingPageComponent, children: [
      { path: 'home', component: HomeComponent },
      { path: 'login/:redirectTo', component: BusinessDetailComponent },
      { path: 'login/:redirectTo/:id', component: BusinessDetailComponent },
      { path: 'BusinessDetail-myads', component: BusinessDetailComponent },
      { path: 'NewTrip', component: NewTripComponent, canActivate: [URLGuard] },
      { path: 'allTrip', component: AllTripComponent, canActivate: [URLGuard] },
      { path: 'news', component: NewsComponent },
      { path: 'News/:id', component: NewsComponent },
      { path: 'about', component: GuidePagesComponent },
      { path: 'general', component: GuidePagesComponent },
      { path: 'drivers', component: GuidePagesComponent },
      { path: 'privacy', component: GuidePagesComponent },
      { path: 'contact-us', component: GuidePagesComponent },
      { path: 'intercity-taxi', component: GuidePagesComponent },
      { path: 'jobs', component: DriverAdsComponent },
      { path: 'job/:title/:id', component: TaxilonAdsDetailComponent },
      { path: 'job/:id', component: TaxilonAdsDetailComponent },
      { path: 'educations', component: EducationComponent },
      { path: 'education/:id', component: EducationComponent },
      { path: 'Profile', component: ProfileComponent },
      { path: 'Support', component: SupportComponent },
      {
        path: 'payment', children: [
          { path: 'callback/prepayment', component: PaymentComponent },
          { path: 'callback', component: FullPaymentComponent },
        ]
      },
      { path: 'route/:id', component: RouteComponent, canActivate: [URLGuard] },

    ]

  },

  // همکاری در تاکسی لون
  {
    path: 'partners', component: LandingPageComponent, children: [
      { path: '', component: HomeMarketersComponent },
      { path: 'dashboard', component: PartnerDashboardComponent, canActivate: [PartnerGuard] },
      { path: 'my-trips', component: PartnerTripsComponent, canActivate: [PartnerGuard] },
      { path: 'financial-report', component: PartnerFinancialComponent, canActivate: [PartnerGuard] },
      { path: 'account', component: PartnerDashboardComponent, canActivate: [PartnerGuard] },
    ]

  }

];

@NgModule({

  imports: [

    RouterModule.forRoot(routes),

  ],

  exports: [RouterModule]

})

export class AppRoutingModule { }
